import { Popover } from "@overmap-ai/blocks"
import { type ComponentPropsWithoutRef, type ComponentPropsWithRef, memo } from "react"

import { IconColorPicker, type IconColorPickerProps } from "../IconColorPicker/IconColorPicker"

export interface IconColorPickerPopoverProps
	extends
		Omit<ComponentPropsWithRef<typeof Popover.Content>, "color">,
		Omit<ComponentPropsWithoutRef<typeof Popover.Root>, "color">,
		IconColorPickerProps {}

export const IconColorPickerPopover = memo<IconColorPickerPopoverProps>((props) => {
	const {
		children,
		open,
		onOpenChange,
		defaultOpen,
		modal,
		selectedIcon,
		onIconChange,
		color,
		onColorChange,
		...rest
	} = props

	return (
		<Popover.Root open={open} onOpenChange={onOpenChange} defaultOpen={defaultOpen} modal={modal}>
			<Popover.Trigger asChild>{children}</Popover.Trigger>
			<Popover.Content {...rest}>
				<IconColorPicker
					selectedIcon={selectedIcon}
					onIconChange={onIconChange}
					color={color}
					onColorChange={onColorChange}
				/>
			</Popover.Content>
		</Popover.Root>
	)
})
IconColorPickerPopover.displayName = "IconColorPickerPopover"
